import './header.scss';

export default async () => {
	$( '.header__toggle' ).click( function (  ) {
		$( this ).toggleClass( 'is-active' );
		$( '.header__mobile-menu' ).fadeToggle();
		$( 'body' ).toggleClass( 'body-hidden' );
		// Append padding, so the header elements dont overlap.
		$( '.header__mobile-menu' ).css( 'padding-top', ( $( '.header__top' ).outerHeight() + $( '.header__header' ).outerHeight() ) );
	} );

	$( '.header__menu > ul > li > ul, .header__menu > ul > li > ul > li > ul' ).parent( 'li' ).addClass( 'has-children' );

	$( '.header__menu > ul > .has-children > a' ).append().after( '<span class=\'header__arrow js-menu-toggle\'><i class=\'icon-chevron-right\'></i></span>' );

	$( '.js-menu-toggle' ).click( function ( e ) {
		e.preventDefault();

		let $this = $( this );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.js-menu-toggle' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.has-children ul' ).slideUp( 350 );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 350 );
		}
	} );

	$( '.wpml-ls-item-toggle' ).click( function ( e ) {
		e.preventDefault();
		$( '.wpml-ls-sub-menu' ).addClass( 'is-active' );
		$( '.header__language-btn' ).addClass( 'is-active' );
	} );
	$( '.header__language-btn' ).click( function ( e ) {
		e.preventDefault();
		$( '.wpml-ls-sub-menu' ).removeClass( 'is-active' );
		$( this ).removeClass( 'is-active' );
	} );
};
